module.exports = __webpack_public_path__ + "assets/img/w-c-9.cb750089.png";